module.exports = __webpack_public_path__ + "static/img/brief_2.0019648.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/brief_2.jpg
// module id = NEca
// module chunks = 1